import { Component } from '@theme/component';

/**
 * SKU display disabled store-wide (keeps custom element + refs for layout compatibility).
 */
class ProductSkuComponent extends Component {
  requiredRefs = ['skuContainer', 'sku'];

  connectedCallback() {
    super.connectedCallback();
    this.#hide();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  /** @param {import('@theme/events').VariantUpdateEvent} _event */
  updateSku = (_event) => {
    this.#hide();
  };

  #hide() {
    this.style.setProperty('display', 'none', 'important');
    if (this.refs.sku) this.refs.sku.textContent = '';
  }
}

if (!customElements.get('product-sku-component')) {
  customElements.define('product-sku-component', ProductSkuComponent);
}
